module.exports = __webpack_public_path__ + "static/media/sponsor.d531b8ae.svg";